import { Icon } from "@screencloud/screencloud-ui-components";
import { FormattedMessage } from "react-intl";
import { PrimaryButton } from "src/helpers/whiteLabel";
import { useAppContext } from "src/hooks/useAppContext";
import { Constants } from "src/billinglatest/constants";
import { getContactUrl } from "src/helpers/onboardingHelper";
import darkPixiIcon from "src/pages/Welcome/images/dark-pixi-icon.svg";
import {
  ButtonContainer,
  Container,
  Description,
  Highlight,
  PixiInlineLogo,
  TalkToSalesButton,
  TitleContainer,
} from "./styles";

type Props = {
  onGetStarted: () => void;
};

const pixiLogoElement = (
  <PixiInlineLogo
    src={darkPixiIcon}
    alt="PIXI"
    data-testid="pixi-trial-expired-logo"
  />
);

export const PixiTrialExpiredModal = ({ onGetStarted }: Props) => {
  const context = useAppContext();

  const firstName = context.currentUser?.givenName;
  const lastName = context.currentUser?.familyName;
  const email = context.currentUser?.email;
  const jobTitle = context.currentUser?.preferences.userInfo?.job?.title;
  const orgName = context.currentOrg?.name;
  const country =
    Constants.Countries[context.currentOrg?.preferences.settings?.country_code];

  const onTalkToSales = () => {
    window.open(
      getContactUrl({
        firstName: firstName ?? "",
        lastName: lastName ?? "",
        email: email ?? "",
        orgName: orgName ?? "",
        jobTitle: jobTitle ?? "",
        country: country ?? "",
      }),
      "_blank",
    );
  };

  const highlight = (
    <Highlight>
      <FormattedMessage
        id="trial_expire_modal.pixi_description_highlight"
        defaultMessage="free {pixiLogo} devices or a subscription discount."
        values={{ pixiLogo: pixiLogoElement }}
      />
    </Highlight>
  );

  return (
    <Container data-testid="pixi-trial-expired-modal">
      <TitleContainer>
        <div className="title">
          <FormattedMessage
            id="trial_expire_modal.title"
            defaultMessage="Your free trial has expired"
          />
        </div>
        <Description data-testid="pixi-trial-expired-description">
          <FormattedMessage
            id="trial_expire_modal.pixi_description"
            defaultMessage="Start your ScreenCloud subscription to continue. Sign up today and receive {highlight}"
            values={{ highlight }}
          />
        </Description>
      </TitleContainer>
      <ButtonContainer>
        <PrimaryButton
          id="pixi-get-started-button"
          data-testid="pixi-get-started-button"
          onClick={onGetStarted}
          fullWidth={true}
        >
          <FormattedMessage
            id="trial_expire_modal.getStarted"
            defaultMessage="Get Started"
          />
        </PrimaryButton>
        <TalkToSalesButton
          id="pixi-talk-to-sales"
          data-testid="pixi-talk-to-sales-button"
          onClick={onTalkToSales}
        >
          <FormattedMessage
            id="trial_expire_modal.talkToSales"
            defaultMessage="Talk to Sales"
          />
          <Icon name="arrow-up-right-circle" />
        </TalkToSalesButton>
      </ButtonContainer>
    </Container>
  );
};
